module.exports = __webpack_public_path__ + "img/Thanos_01.0b2c29ba.png";